export default {
    company_role: {
        admin: 'ADMINISTRATOR',
        user: 'KORISNIK',
    },
    click_email: 'Klikni za email',
    click_phone: 'Klikni za broj telefona',
}
